import {ActionTypes} from "./types";

const INITIAL_STATE = {
  countries: undefined,
  allCountries: undefined
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
      };
    case ActionTypes.SET_ALL_COUNTRIES:
      return {
        ...state,
        allCountries: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;